import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import AuthorizeRoute from './common/routes/AuthorizeRoute';
import { ApplicationPaths, LoginActions, LogoutActions } from './Config';
import IdentityLoginScreen from './screens/identity/IdentityLoginScreen';
import IdentityLogoutScreen from './screens/identity/IdentityLogoutScreen';
import AuthenticatedLayout from './common/layouts//authenticatedLayout/AuthenticatedLayout';
//import ProtectedRoute from './common/routes/ProtectedRoute';
import AccountScreen from './screens/account/AccountScreen';
import NotFoundScreen from './screens/errors/NotFoundScreen';
import VehiclesManagementScreen from 'screens/vehicles-management/VehiclesManagementScreen';
import PolicyRoute from 'common/routes/PolicyRoute';
import VehicleScreen from 'screens/vehicle/VehicleScreen';
import SettingsScreen from 'screens/settings/SettingsScreen';
import SecurityScreen from 'screens/security/SecurityScreen';
import ListChargesScreen from 'screens/charges/ListChargesScreen';
import PlafondsReportScreen from 'screens/plafonds-report/PlafondsReportScreen';
import ChargeScreen from 'screens/vehicle/components/carChargeTab/components/ChargeScreen';
import CompaniesScreen from 'screens/companies/CompaniesScreen';
import AdminAnnouncementsScreen from 'screens/announcements/AdminAnnouncementsScreen';
import AnnouncementDetailsScreen from 'screens/announcements/AnnouncementDetailsScreen';
import ImportDataScreen from 'screens/import-data/ImportDataScreen';
import UpdateVehicleSegments from 'screens/god-mode/updateVehicleSegments/UpdateVehicleSegments';
import CompanyScreen from 'screens/company/CompanyScreen';
import DriversScreen from 'screens/drivers/DriversScreen';
import DriverScreen from 'screens/driver/DriverScreen';
import VerificationScreen from 'screens/verification/VerificationScreen';
import AlertsScreen from 'screens/alerts/AlertsScreen';
import { useSelector } from 'react-redux';
import { Reducers } from 'store/types';
import { UserProfile } from 'api/account/models/UserProfile';
import ForbiddenScreen from 'screens/errors/ForbiddenScreen';
import UsersService from 'api/users/UsersService';
import MaintenancesScreen from 'screens/maintenances/MaintenancesScreen';
import VehiclesScreen from 'screens/vehicles/VehiclesScreen';
import ReservationScreen from 'screens/reservations/ReservationScreen';
import DashboardScreen from 'screens/dashboard/DashboardScreen';
import ImportChargeScreen from 'screens/import-charges/ImportChargeScreen';
import ImportChargesScreen from 'screens/import-charges/ImportChargesScreen';
import VehiclesMileageScreen from 'screens/vehicles-mileage/VehiclesMileageScreen';
import NewAccount from 'screens/new_account/NewAccountScreen';
import VehiclesGpsScreen from 'screens/vehicles-gps/VehiclesGpsScreen';
import AlarmsListScreen from 'screens/alarms/components/alarmsList/AlarmsListScreen';
import AlarmScreen from 'screens/alarms/AlarmScreen';
import VisitsReportScreen from 'screens/visits-report/VisitsReportScreen';
import AdminNotificationsList from 'screens/notifications/AdminNotificationsList';
import AdminNotificationsScreen from 'screens/notifications/AdminNotificationScreen';
import DownloadAppScreen from 'screens/errors/DownloadAppScreen';
import { useEffect, useState } from 'react';
import RemindersScreen from 'screens/reminders/RemindersScreen';
import AdminRulesScreen from 'screens/security/AdminRulesScreen';
import AdminRolesSecurity from 'screens/security/AdminRolesScreen';
import GeofencesListScreen from 'screens/geofences/GeofencesListScreen';
import GeofenceScreen from 'screens/geofence/GeofenceScreen';
import UpdateGeofencesToTrackingDB from 'screens/god-mode/updateGeofencesToTrackingDB/UpdateGeofencesToTrackingDB';
import CalculateMonthlyCostsScreen from 'screens/god-mode/calculate-monthly-costs/CalculateMonthlyCostsScreen';
import CalculateAllMonthlyCostsScreen from 'screens/god-mode/calculate-all-monthly-costs/CalculateAllMonthlyCostsScreen';
import RunAddressHydrationScreen from 'screens/god-mode/run-address-hydration/RunAddressHydrationScreen';
import PrefillCapacityFromGps from 'screens/god-mode/prefillCapacityFromGps/PrefillCapacityFromGps';
import GodModesScreen from 'screens/god-mode/GodModesScreen';

import ChargeGeofenceScreen from 'screens/charges/components/chargeGeofence/ChargeGeofenceScreen';
import ContractsScreen from 'screens/contracts/ContractsScreen';
import BulkContractsScreen from 'screens/bulk-contracts/BulkContractsScreen';
import PlatformSettingsScreen from 'screens/platform/PlatformSettingsScreen';


const HomeRedirection = () => {
    const loggedUser = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const policies = loggedUser?.policies || [];
    const userIssues = loggedUser?.issues || [];

    if (userIssues.length > 0) {
        return <Redirect to={{ pathname: '/account/details/subscription' }} />
    }
    else if (UsersService.hasPolicies(policies, ['SETTINGUP_VEHICLES_READ'])) {
        return <Redirect to="/vehicles" />;
    } else if (UsersService.hasPolicies(policies, ['SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'])) {
        return <Redirect to="/companies" />;
    } else if (UsersService.hasPolicies(policies, ['SETTINGUP_DASHBOARDS_READ'])) {
        return <Redirect to="/dashboard" />;
    } else if (UsersService.hasPolicies(policies, ['SETTINGUP_USERS_READ', 'SETTINGUP_USERS_WRITE'])) {
        return <Redirect to="/security" />;
    }

    return <Redirect to="/403" />;

}

const DefaultRouter = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsSmallScreen(window.innerWidth < 768); //sm size
        };

        checkScreenSize(); // Check initially

        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    if (isSmallScreen) {
        return <DownloadAppScreen />
    } 

    return (
        <Router>
            <Switch>
                <Route path="/404" component={NotFoundScreen} />
                <Route path="/403" component={ForbiddenScreen} />
                <Route path={ApplicationPaths.Login} render={() => (<IdentityLoginScreen action={LoginActions.Login} />)} />
                <Route path={ApplicationPaths.Reset} render={() => (<IdentityLoginScreen action={LoginActions.Reset} />)} />
                <Route path={ApplicationPaths.LoginFailed} render={() => (<IdentityLoginScreen action={LoginActions.LoginFailed} />)} />
                <Route path={ApplicationPaths.LoginCallback} render={() => (<IdentityLoginScreen action={LoginActions.LoginCallback} />)} />
                <Route path={ApplicationPaths.LogOut} render={() => (<IdentityLogoutScreen action={LogoutActions.Logout} />)} />
                <Route path={ApplicationPaths.LogOutCallback} render={() => (<IdentityLogoutScreen action={LogoutActions.LogoutCallback} />)} />

                <AuthorizeRoute path="*">
                    <AuthenticatedLayout>
                        <Switch>
                            <Route path="/" exact component={HomeRedirection} />
                            <Route path="/account/:type/:tabid?" exact component={AccountScreen} />
                            <PolicyRoute path="/create_account" exact component={NewAccount} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            {/* Enterprises */}
                            <PolicyRoute path="/companies" exact component={CompaniesScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            {/* Import Data */}
                            <PolicyRoute path="/import-data" exact component={ImportDataScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_WRITE', 'SETTINGUP_IMPORT_DATA_WRITE'
                            ]} />
                            {/* Announcements (Avisos) */}
                            <PolicyRoute path="/avisos" exact component={AdminAnnouncementsScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            <PolicyRoute path="/avisos/:type/:itemId?" exact component={AnnouncementDetailsScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            {/* ADMIN */}
                            <PolicyRoute path="/companies/:type/:id?/:tabId?/:tabType?/:childrenId?" exact component={CompanyScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            <PolicyRoute path="/notifications" exact component={AdminNotificationsList} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            <PolicyRoute path="/notifications/:type/:itemId?" exact component={AdminNotificationsScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            <PolicyRoute path="/rules" exact component={AdminRulesScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            <PolicyRoute path="/roles" exact component={AdminRolesSecurity} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            <PolicyRoute path="/roles/:tabType/:childrenId?" exact component={AdminRolesSecurity} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            {/* <PolicyRoute path="/companies/:type/:companyId?/:tabId?/:tabType/:childrenId?" exact component={AdminRolesSecurity} type='OR' policies={[
                                'SETTINGUP_COMPANIES_READ', 'SETTINGUP_COMPANIES_WRITE'
                            ]} /> */}
                            {/* DASHBOARD */}
                            <PolicyRoute path="/dashboard" exact component={DashboardScreen} type='OR' policies={[
                                'SETTINGUP_DASHBOARDS_READ'
                            ]} />
                            {/* Voitures */}
                            <PolicyRoute path="/vehicles-management" exact component={VehiclesManagementScreen} type='OR' policies={[
                                'SETTINGUP_VEHICLES_MANAGEMENT_READ', 'SETTINGUP_VEHICLES_MANAGEMENT_WRITE'
                            ]} />
                            <PolicyRoute path="/vehicles-mileage" exact component={VehiclesMileageScreen} type='OR' policies={[
                                'SETTINGUP_VEHICLES_MILEAGE_READ', 'SETTINGUP_VEHICLES_MILEAGE_WRITE'
                            ]} />
                            {/* Contracts Listing */}
                            <PolicyRoute path="/contracts" exact component={ContractsScreen} type='OR' policies={[
                                'SETTINGUP_CONTRACTS_READ', 'SETTINGUP_CONTRACTS_WRITE'
                            ]} />
                            {/* Task #66347: atualização/inserção em massa de contratos */}
                            <PolicyRoute path="/bulk-contracts" exact component={BulkContractsScreen} type='OR' policies={[
                                'SETTINGUP_CONTRACTS_WRITE'
                            ]} />
                            <PolicyRoute path="/vehicles" exact component={VehiclesScreen} type='OR' policies={[
                                'SETTINGUP_VEHICLES_READ', 'SETTINGUP_VEHICLES_WRITE'
                            ]} />

                            {/* CLICK ON VISIT REPORT TO GO TO TRIP INSIDE CAR  */}
                            <PolicyRoute path="/vehicles/trip/:type/:vehicleId/:tabId/:itemType/:tripDate/:tripId/:geofenceId" exact component={VehicleScreen} type='OR' policies={[
                                'SETTINGUP_VEHICLES_READ', 'SETTINGUP_VEHICLES_WRITE',
                                'SETTINGUP_VEHICLES_MANAGEMENT_READ', 'SETTINGUP_VEHICLES_MILEAGE_READ', 'SETTINGUP_VEHICLES_MANAGEMENT_WRITE'
                            ]} />
 
                            <PolicyRoute path="/vehicles/:type/:vehicleId?/:tabId?/:itemType?/:itemId?/:contractType?/:contractId?/:month?/:returnUrl?" exact component={VehicleScreen} type='OR' policies={[
                                'SETTINGUP_VEHICLES_READ', 'SETTINGUP_VEHICLES_WRITE',
                                'SETTINGUP_VEHICLES_MANAGEMENT_READ', 'SETTINGUP_VEHICLES_MILEAGE_READ', 'SETTINGUP_VEHICLES_MANAGEMENT_WRITE'
                            ]} /> 


                            {/* Conducteurs */}
                            <PolicyRoute path="/drivers" exact component={DriversScreen} type='OR' policies={[
                                'SETTINGUP_DRIVERS_READ'
                            ]} />
                            <PolicyRoute path="/drivers/:type/:driverId?/:tabId?/:itemType?/:itemId?" exact component={DriverScreen} type='OR' policies={[
                                'SETTINGUP_DRIVERS_READ'
                            ]} />
                            {/* Frais */}
                            <PolicyRoute path="/charges" exact component={ListChargesScreen} type='OR' policies={[
                                'SETTINGUP_CHARGES_READ', 'SETTINGUP_CHARGES_WRITE'
                            ]} />
                            <PolicyRoute path="/charges/:type/:itemId?" exact component={ChargeScreen} type='OR' policies={[
                                'SETTINGUP_CHARGES_READ', 'SETTINGUP_CHARGES_WRITE'
                            ]} />
                            {/* #66600 — relatório de consumo vs plafond da frota */}
                            <PolicyRoute path="/plafonds-report" exact component={PlafondsReportScreen} type='OR' policies={[
                                'SETTINGUP_DASHBOARDS_READ'
                            ]} />
                            <PolicyRoute path="/charge-geofenses" exact component={ChargeGeofenceScreen} type='OR' policies={[
                                'SETTINGUP_CHARGES_READ', 'SETTINGUP_CHARGES_WRITE'
                            ]} />
                            {/* Alertes */}
                            <PolicyRoute path="/alerts" exact component={AlertsScreen} type='OR' policies={[
                                'SETTINGUP_ALERTS_READ'
                            ]} />
                            {/* Maintenances */}
                            <PolicyRoute path="/maintenances/:type?/:itemId?/" exact component={MaintenancesScreen} type='OR' policies={[
                                'SETTINGUP_VEHICLE_MAINTENANCES_READ', 'SETTINGUP_VEHICLE_MAINTENANCES_WRITE'
                            ]} />
                            {/* Verifications */}
                            <PolicyRoute path="/verifications/:type?/:itemId?/" exact component={VerificationScreen} type='OR' policies={[
                                'SETTINGUP_VERIFICATIONS_READ', 'SETTINGUP_VERIFICATIONS_WRITE'
                            ]} />
                            {/* Reservations*/}
                            <PolicyRoute path="/reservations/:type?/:itemId?/" exact component={ReservationScreen} type='OR' policies={[
                                'SETTINGUP_RESERVATIONS_READ', 'SETTINGUP_RESERVATIONS_WRITE'
                            ]} />
                            {/* Utilisateurs */}
                            <PolicyRoute path="/settings/:tabId?/:type?/:itemId?" exact component={SettingsScreen} type='OR' policies={[
                                'SETTINGUP_GENERIC_TYPES_READ', 'SETTINGUP_GENERIC_TYPES_WRITE',
                                'SETTINGUP_VEHICLE_SEGMENTS_READ', 'SETTINGUP_VEHICLE_SEGMENTS_WRITE',
                                'SETTINGUP_VEHICLE_BRANDS_READ', 'SETTINGUP_VEHICLE_BRANDS_WRITE',
                                'SETTINGUP_VEHICLE_MODELS_READ', 'SETTINGUP_VEHICLE_MODELS_WRITE',
                                'SETTINGUP_SUPPLIERS_READ', 'SETTINGUP_SUPPLIERS_WRITE',
                                'SETTINGUP_LOCALS_READ', 'SETTINGUP_LOCALS_WRITE',
                                'SETTINGUP_DIAGNOSTIC_TYPES_READ', 'SETTINGUP_DIAGNOSTIC_TYPES_WRITE',
                                'SETTINGUP_COMMUNICATIONS_READ', 'SETTINGUP_COMMUNICATIONS_WRITE',
                                'SETTINGUP_NOTIFICATIONS_READ', 'SETTINGUP_NOTIFICATIONS_WRITE'
                            ]} />
                            {/* Platform-only system settings */}
                            <PolicyRoute path="/platform/system-settings" exact component={PlatformSettingsScreen} type='OR' policies={[
                                'SETTINGUP_COMPANIES_WRITE'
                            ]} />
                            {/* Paramétrages */}
                            <PolicyRoute path="/security/:tabId?/:type?/:id?" exact component={SecurityScreen} type='OR' policies={[
                                'SETTINGUP_USERS_READ', 'SETTINGUP_USERS_WRITE'
                            ]} />
                            {/* ImportCharges*/}

                            <PolicyRoute path="/import-charges" exact component={ImportChargesScreen} type='OR' policies={[
                                'SETTINGUP_IMPORT_EXPENSES_WRITE'
                            ]} />

                            <PolicyRoute path="/import-charges/:type?/:itemId?/" exact component={ImportChargeScreen} type='OR' policies={[
                                'SETTINGUP_IMPORT_EXPENSES_WRITE'
                            ]} />
                            <PolicyRoute path="/vehicles-gps" exact component={VehiclesGpsScreen} type='OR' policies={['SETTINGUP_GPS_READ']} />
                            {/* Admin GodMode */}
                            <PolicyRoute path="/god-modes" exact component={GodModesScreen} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            <PolicyRoute path="/god-mode/calculate-monthly-costs/:companyId?" exact component={CalculateMonthlyCostsScreen} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            <PolicyRoute path="/god-mode/calculate-all-monthly-costs" exact component={CalculateAllMonthlyCostsScreen} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            <PolicyRoute path="/god-mode/updateSegmentsImages" exact component={UpdateVehicleSegments} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            <PolicyRoute path="/god-mode/updateGeofencesToTrackingDB" exact component={UpdateGeofencesToTrackingDB} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            <PolicyRoute path="/god-mode/run-address-hydration" exact component={RunAddressHydrationScreen} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            <PolicyRoute path="/god-mode/prefill-capacity-from-gps" exact component={PrefillCapacityFromGps} type='OR' policies={['SETTINGUP_COMPANIES_WRITE']} />
                            {/* Alarms */}
                            <PolicyRoute path="/alarms" exact component={AlarmsListScreen} type='OR' policies={['SETTINGUP_GPS_READ']} />
                            <PolicyRoute path="/alarms/:type/:alarmId?" exact component={AlarmScreen} type='OR' policies={['SETTINGUP_GPS_READ']} />

                            <PolicyRoute path="/geofences" exact component={GeofencesListScreen} type='OR' policies={['SETTINGUP_COST_CENTER_READ','SETTINGUP_COST_CENTER_WRITE']} />
                            <PolicyRoute path="/geofences/:type/:itemId?" exact component={GeofenceScreen} type='OR' policies={['SETTINGUP_COST_CENTER_READ','SETTINGUP_COST_CENTER_WRITE']} />
                            
                            <PolicyRoute path="/visits-report" exact component={VisitsReportScreen} type='OR' policies={['SETTINGUP_GPS_READ']} />

                            <PolicyRoute path="/reminders/:type?/:itemId?" exact component={RemindersScreen} type='OR' policies={[
                                'SETTINGUP_REMINDER_WRITE', 'SETTINGUP_REMINDER_READ'
                            ]} />

                            <Route>
                                <Redirect to="/404" />
                            </Route>
                        </Switch>
                    </AuthenticatedLayout>
                </AuthorizeRoute>
                <Route path="*">
                    <Redirect to="/404" />
                </Route>
            </Switch>
        </Router>
    );
}

export default DefaultRouter;
